import React from 'react';

function Footer() {
  return (
    <div style={{ backgroundColor: 'var(--color-primary)', textAlign: 'center', padding: '40px 24px', color: 'rgba(255,255,255,0.8)' }}>
      <img src="/images/logo_testa_cane_fix.gif" alt="Glad Dogs" style={{ height: '150px', marginBottom: '24px' }} />
      <div>
        &copy; Gladdogs 2026 website realizzato da <a href="https://makehubstudio.com" target="_blank" rel="noreferrer" style={{ color: 'var(--color-white)', textDecoration: 'underline' }}>Make Hub Studio</a>
        <br />
        <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center', gap: '16px' }}>
          <a href="#/privacy" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '12px', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = 'rgba(255,255,255,1)'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.6)'}>Privacy & Cookie Policy</a>
          <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
          <a href="#/admin/add-dog" style={{ color: 'rgba(255,255,255,0.2)', textDecoration: 'none', fontSize: '11px', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.2)'}>Area riservata</a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
